import React, { Grid, Paper, Typography } from '@mui/material';
import { OrganizationChart, SelectPartnerForOverview } from 'components';
import { useAuth } from 'hooks';
import { useState } from 'react';

export const Organization = () => {
	const { currentUserId } = useAuth();
	const [selectedPartnerId, setSelectedPartnerId] = useState<number | undefined>(currentUserId);
	return (<>
		<Grid container spacing={2} p={2} display='flex' component={Paper} justifyContent='center' alignItems='center' height={'calc(100vh - 60px)'}>
			<Grid item xs={8} />
			<Grid item xs={4}>
				<Typography variant='subtitle1' display={'inline-flex'}>Select user:</Typography>
				<SelectPartnerForOverview partnerId={selectedPartnerId} setPartnerId={setSelectedPartnerId} />
			</Grid>
			<Grid item xs={12} height={'100%'} component={Paper}>
				<OrganizationChart selectedPartnerId={selectedPartnerId} setPartnerId={setSelectedPartnerId} />
			</Grid>
		</Grid>
	</>
	)
};